// extracted by mini-css-extract-plugin
export var fullGrid = "_36-3";
export var pdpPreviewContainer = "_36-1";
export var previewContainer = "_36-0";
export var togglePreviewContainer = "_36-2";